<template>
  <div class="module--cp_zone_assignment">
    <DashBlock :title="$t('label.assign_cp_to_zone')">
      <el-row :gutter="10">
        <el-col v-for="cp in cps" :key="cp.cp_id" class="cp" :span="6">
          <input type="checkbox"
            :id="cp.cp_no"
            :value="cp.cp_id"
            v-model="assigned"
          />
          <label class="label" :for="cp.cp_no">{{ cp.cp_no }}</label>
        </el-col>
      </el-row>
      <div class="action">
        <el-button size="small" type="primary" @click="assign">{{ $t("button.confirm") }}</el-button>
      </div>
    </DashBlock>
  </div>
</template>

<script>
import DashBlock from "@/components/modules/dashboard/DashBlock";

export default {
  props: ["data"],
  components: {
    DashBlock
  },
  async beforeMount() {
    await this.$axios.get(`/cps/loc_id/${this.data.loc_id.loc_id}/zone_id/${this.data.zone_id}/zone_assignment`).then(res=>{
      this.cps = res.data;
      this.cps.map(cp=>{
        if(cp.zone_id && cp.zone_id.zone_id == this.data.zone_id) {
          this.orig.push(cp.cp_id);
          this.assigned.push(cp.cp_id);
        }
      });
    });
  },
  methods: {
    assign() {
      let result = [];
      this.cps.map(cp=>{
        if(this.orig.includes(cp.cp_id) && !this.assigned.includes(cp.cp_id)) {
          result.push({
            cp_id: cp.cp_id,
            action: "remove"
          });
        }else if(!this.orig.includes(cp.cp_id) && this.assigned.includes(cp.cp_id)) {
          result.push({
            cp_id: cp.cp_id,
            action: "add"
          });
        }
      });
      this.$axios.put(`cps/assign_zone/${this.data.zone_id}`, result)
      console.log("result: ", result);
    }
  },
  data() {
    return {
      cps: [],
      orig: [],
      assigned: []
    }
  }
}
</script>

<style lang="scss">
.module--cp_zone_assignment{
  width: 100%;
  .cp{
    display: flex;
  }
  .action{
    justify-content: flex-end!important;
  }
}
</style>